const sliderCollection = document.querySelector('[data-slider-collections]');
if (sliderCollection) {
  let sliderCollectionSwiper = new Swiper('[data-slider-collections]', {
    slidesPerView: 3,
    allowTouchMove: false,
    resistanceRatio: 0.000001,
    loop: false,
    debugger: true,
    navigation: {
      nextEl: '.collections-slider__button--next',
      prevEl: '.collections-slider__button--prev',
    },
    scrollbar: {
      el: ".swiper-scrollbar--collections",
      hide: false,
      draggable: true,
    },
    breakpoints: {
      320: {
        allowTouchMove: true,
        slidesPerView: 1,
        spaceBetween: 40,
      },
      991: {
        allowTouchMove: false,
        slidesPerView: 'auto',
        spaceBetween: 40,
      },
      1600: {
        slidesPerView: 3,
        spaceBetween: 80,
      },
    }
  });

  sliderCollectionSwiper.on('slideChange', function () {
    let cardEffect = document.querySelectorAll('.c-card--effect-second-image')
    if (cardEffect.length > 0) {
      for(let i = 0; i < cardEffect.length ; i++) {
        cardEffect[i].classList.remove('c-card--active')
      }
    }
  });

  document
    .querySelector('.collections-slider__button--slide-to-start')
    .addEventListener('click', function (e) {
      e.preventDefault();
      sliderCollectionSwiper.slideTo(0, 0);
    });

  document
    .querySelector('.collections-slider__button--slide-to-finish')
    .addEventListener('click', function (e) {
      e.preventDefault();
      sliderCollectionSwiper.slideTo(99, 0);
    });
}

const sliderProducts = document.querySelector('[data-slider-products]');
if (sliderProducts) {
  let sliderProductsSwiper = new Swiper('[data-slider-products]', {
    slidesPerView: 3,
    allowTouchMove: false,
    resistanceRatio: 0.000001,
    loop: false,
    debugger: true,
    navigation: {
      nextEl: '.products-slider__button--next',
      prevEl: '.products-slider__button--prev',
    },
    scrollbar: {
      el: ".swiper-scrollbar--products",
      hide: false,
      draggable: true,
    },
    breakpoints: {
      320: {
        allowTouchMove: true,
        slidesPerView: 1,
        spaceBetween: 50,
      },
      500: {
        allowTouchMove: true,
        slidesPerView: 'auto',
        spaceBetween: 50,
      },
      991: {
        allowTouchMove: false,
        slidesPerView: 'auto',
        spaceBetween: 40,
      },
      1600: {
        slidesPerView: 3,
        spaceBetween: 80,
      },
    }
  });

  document
    .querySelector('.products-slider__button--slide-to-start')
    .addEventListener('click', function (e) {
      e.preventDefault();
      sliderProductsSwiper.slideTo(0, 0);
    });

  document
    .querySelector('.products-slider__button--slide-to-finish')
    .addEventListener('click', function (e) {
      e.preventDefault();
      sliderProductsSwiper.slideTo(99, 0);
    });
}

const sliderBlogs = document.querySelector('[data-slider-blogs]');
if (sliderBlogs) {
  let sliderBlogsSwiper = new Swiper('[data-slider-blogs]', {
    slidesPerView: 3,
    allowTouchMove: false,
    resistanceRatio: 0.000001,
    loop: false,
    debugger: true,
    navigation: {
      nextEl: '.blogs-slider__button--blogs-next',
      prevEl: '.blogs-slider__button--blogs-prev',
    },
    scrollbar: {
      el: ".swiper-scrollbar--blogs",
      hide: false,
      draggable: true,
    },
    breakpoints: {
      320: {
        allowTouchMove: true,
        slidesPerView: 1,
        spaceBetween: 50,
      },
      500: {
        allowTouchMove: true,
        slidesPerView: 'auto',
        spaceBetween: 50,
      },
      991: {
        allowTouchMove: false,
        slidesPerView: 'auto',
        spaceBetween: 40,
      },
      1600: {
        slidesPerView: 3,
        spaceBetween: 80,
      },
    }
  });

  document
    .querySelector('.blogs-slider__button--slide-to-start')
    .addEventListener('click', function (e) {
      e.preventDefault();
      sliderBlogsSwiper.slideTo(0, 0);
    });

  document
    .querySelector('.blogs-slider__button--slide-to-finish')
    .addEventListener('click', function (e) {
      e.preventDefault();
      sliderBlogsSwiper.slideTo(99, 0);
    });

  let menuElements = document.querySelectorAll('[data-tab]');
  for(let i = 0; i < menuElements.length ; i++) {
    menuElements[i].addEventListener('click', function () { sliderBlogsSwiper.scrollbar.updateSize() }, false);
  }
}

const sliderBlogsRecipes = document.querySelector('[data-slider-recipes]');
if (sliderBlogsRecipes) {
  let sliderBlogsRecipes = new Swiper('[data-slider-recipes]', {
    slidesPerView: 3,
    allowTouchMove: false,
    resistanceRatio: 0.000001,
    loop: false,
    debugger: true,
    navigation: {
      nextEl: '.blogs-slider__button--recipes-next',
      prevEl: '.blogs-slider__button--recipes-prev',
    },
    scrollbar: {
      el: ".swiper-scrollbar--recipes",
      hide: false,
      draggable: true,
    },
    breakpoints: {
      320: {
        allowTouchMove: true,
        slidesPerView: 1,
        spaceBetween: 50,
      },
      500: {
        allowTouchMove: true,
        slidesPerView: 'auto',
        spaceBetween: 50,
      },
      991: {
        allowTouchMove: false,
        slidesPerView: 'auto',
        spaceBetween: 40,
      },
      1600: {
        slidesPerView: 3,
        spaceBetween: 80,
      },
    }
  });

  document
    .querySelector('.blogs-slider__button--slide-to-start-2')
    .addEventListener('click', function (e) {
      e.preventDefault();
      sliderBlogsRecipes.slideTo(0, 0);
    });

  document
    .querySelector('.blogs-slider__button--slide-to-finish-2')
    .addEventListener('click', function (e) {
      e.preventDefault();
      sliderBlogsRecipes.slideTo(99, 0);
    });

  let menuElements = document.querySelectorAll('[data-tab]');
  for(let i = 0; i < menuElements.length ; i++) {
    menuElements[i].addEventListener('click', function () { sliderBlogsRecipes.scrollbar.updateSize() }, false);
  }
}
